'use strict';
var annotate = require('annotate');


module.exports = annotate('random', 'Returns a floating-point, pseudo-random number in the range [0, 1)').
    on(Math.random);



//////////////////
// WEBPACK FOOTER
// ./~/annomath/lib/random.js
// module id = 758
// module chunks = 0